export const ADD_PROJECT = 'ADD_PROJECT';
export const TOGGLE_MENU = 'TOGGLE_MENU';



// WEBPACK FOOTER //
// ./src/store/types.js